module.exports = __webpack_public_path__ + "img/body.e06900e8.png";